import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'
import ForgetPassword from '../components/ForgetPassword'
import config from '../config'
import { loginUser } from '../ducks/auth'
import whiteArrow from '../images/right-arrow-white.png'
import routes from '../routes'
import { COLORS, SIZES } from '../styles/theme'
import { toast } from 'react-toastify'

const LoginBox = styled.section`
  position: fixed;
  bottom: 5vh;
  right: 0vw;
  padding: 4vw;
  padding-bottom: 0;
  max-height: 100%;
  text-align: center;
  color: white;

  .action-text {
    font-weight: bold;
    color: #ff9821;
    cursor: pointer;
  }

  form {
    background: #fff;
    color: #404040;
    padding: 30px 10px;
    border-radius: 28px;
    margin: auto;
    margin-top: 30px;
    max-width: 375px;

    input {
      width: 80%;
      background: ${COLORS.lightGray};
      border: none;
      padding: 12px 28px;
      border-radius: 20px;
      margin-top: 20px;

      &::placeholder {
        color: ${COLORS.lightGray1};
      }
    }

    .forget-pass {
      width: 80%;
      color: ${COLORS.primaryTrans};
      margin-top: 10px;
      font-size: 0.9em;
    }

    .login-btn {
      background: linear-gradient(#f5ba18, #d00937);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      margin-right: 2em;
      margin-top: 1em;
      margin-bottom: 0em;
      border-radius: 50%;
      letter-spacing: 1px;
      width: 60px;
      height: 60px;
      cursor: pointer;
      opacity: 1;
      outline: none;
      border: none;
      input {
        cursor: pointer;
        opacity: 0;
        padding: 0;
        margin: 0;
        display: none;
      }
    }
    .title {
      font-weight: 500;
      font-size: 20px;
      margin: 0;
      color: #404040;
    }
    .white-arrow {
      width: 24px;
      line-height: 60px;
      cursor: pointer;
    }
  }
  div.privacy {
    margin: 0 auto;
    width: 90%;
    margin-top: 12px;
  }
  .form-check {
    display: flex;
    align-items: flex-start;
    padding: 0;
    font-weight: 500;
    .agree-box {
      padding: 8px;
      margin-top: 4px;
      width: 20%;
    }
    .form-check-label {
      color: #404040;
      font-size: 11px;
      margin-left: 8px;
      a {
        text-decoration: underline;
      }
    }
  }

  #support-link {
    font-size: 11px;
    text-decoration: underline;
  }

  ${SIZES.mobile} {
    form {
      border-radius: 10px;
    }
  }
`

export default function LoginPage() {
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [agree, setAgree] = useState(false)
  const [expand, setExpand] = useState(false)
  const { isFetching, isAuthenticated } = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const handleCheckBox = (e) => {
    const { checked } = e.target
    setAgree(checked)
    setExpand(true)
  }

  const handleExpand = () => {
    setExpand(!expand)
  }
  const handleLogin = (e) => {
    e.preventDefault()
    if (!agree) {
      toast('Please indicate that you have read and agree to the Terms and Conditions and Privacy Notice before login')
      return
    }
    dispatch(
      loginUser({
        email,
        password,
      })
    )
  }
  const onPasswordInput = (e) => {
    setPassword(e.target.value.toLowerCase())
  }

  const onEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }

  useEffect(() => {
    document.title = `${config.eventName} | Login`
  }, [])

  if (isAuthenticated) {
    return <Redirect to={routes.lobby} />
  } else {
    return (
      <LoginBox>
        <form onSubmit={handleLogin}>
          <p className="title">Login</p>
          <input type="email" placeholder="Email Address" value={email} onChange={onEmailInput} />
          <input type="password" value={password} placeholder="Password" onChange={onPasswordInput} />

          <div className="privacy mb-2">
            <div className="form-check">
              <input type="checkbox" className="agree-box" onChange={handleCheckBox} />
              <label className="form-check-label text-left">
                <span className="text-danger">*</span>&nbsp; I hereby acknowledge that I have read and understood this&nbsp;
                {/* <a href="https://drive.google.com/file/d/12DEaHCVtQvNX7-417k-z28z-k9RmZXOZ/view?usp=sharing" target="_blank" rel="noopener noreferrer"> */}
                <b>Personal Data Protection Privacy Notice</b>
                {/* </a> */}
                {expand ? (
                  <span onClick={handleExpand}>
                    . By checking this box, I acknowledge agreeing to the registration terms and conditions as well as consent to the processing of my personal
                    data in accordance with the terms of this privacy notice.
                  </span>
                ) : (
                  <span onClick={handleExpand} className="text-secondary font-weight-bold">
                    ...&nbsp;&nbsp;Read More
                  </span>
                )}
              </label>
            </div>
          </div>

          <br />
          <div>
            <small className="text-secondary font-weight-bold">Forgot Password?&nbsp;</small>
            <a
              href={`${process.env.NODE_ENV === 'production' ? 'https://icse2021.live' : 'http://localhost:3000'}/password/new`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <small className="action-text">Click Here</small>
            </a>
          </div>
          <button
            type="submit"
            className="btn login-btn"
            onClick={handleLogin}
            style={{ background: isFetching ? 'lightgray' : 'linear-gradient(#F5BA18, #D00937)' }}
          >
            <input disabled={!(email.length && password.length) || isFetching} value={isFetching ? '' : ''} />
            <div>
              <img src={whiteArrow} className="white-arrow" alt="icon" />
            </div>
          </button>
        </form>
      </LoginBox>
    )
  }
}
